import { storage, db } from "./firebase";
import ImageResizor from "image-resizor";
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";
import { collection, addDoc } from "firebase/firestore";
import { writable } from "svelte/store";
import { v4 as uuidv4 } from "uuid";

const MAIL_COLLECTION = "mail";
const UPLOAD = "upload";

const mailUpload = () => {
  const mailLoading = writable(false);
  const mailError = writable(false);
  const mailSuccess = writable(false);

  const resetMailStore = () => {
    mailError.set(false);
    mailLoading.set(false);
    mailSuccess.set(false);
  };

  const sendMail = async (payload) => {
    if (!payload) return;
    let attach = false;
    resetMailStore();
    mailLoading.set(true);
    const { name, email, phone, message, time } = payload;

    if (UPLOAD in payload) attach = true;

    const emailString = `
    
    <!DOCTYPE html>
<html>

<head>
    <meta charset="utf-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <title>One column layout</title>
    <style>
    body {
      font: normal medium/1.4 sans-serif;
    }
    table {
      border-collapse: collapse;
      width: 100%;
    }
    th, td {
      padding: 0.25rem;
      text-align: left;
      border: 1px solid #ccc;
    }
    tbody tr:nth-child(odd) {
      background: #eee;
    }
    </style>
    </head>
    <body>
    
    <table>
    <tr>
      <th colspan="2">local date & time for user is ${time}</th>
    </tr>
    <tbody>
    <tr><td><strong>Name</strong></td>
    <td>
    ${name}
    </td>
    </tr>
    <tr><td><strong>Email</strong></td>
    <td>
    <a href="mailto:${email}">${email}</a>
    </td>
    </tr>
    <tr><td><strong>Phone</strong></td>
    <td>
    ${phone}
    </td>
    </tr>
    <tr><td><strong>Message</strong></td>
    <td>
    ${message}
    </td>
    </tr>
    <tr><td><strong>Attachment</strong></td>
    <td>
    ${
      attach
        ? `<a href=
    ${payload.upload}>Attachment</a>`
        : ""
    }
    </td>
    </tr>
    
    </tbody></table></body></html>`;

    const template = {
      to: "powers.matthew.douglas@gmail.com",
      message: {
        subject: `New Inquiry from ${name}`,
        html: emailString,
      },
    };

    try {
      const docRef = await addDoc(collection(db, "mail"), template);
      if (!docRef) throw new Error("couldnt get the docRef");
      mailSuccess.set(true);
      return true;
    } catch (err) {
      console.log(err);
      mailError.set(true);
    } finally {
      mailLoading.set(false);
    }
  };

  return {
    mailLoading,
    mailError,
    mailSuccess,
    resetMailStore,
    sendMail,
  };
};

const fileUpload = () => {
  const imageLoading = writable(false);
  const imageError = writable(false);
  const imageUrl = writable(null);
  const storeAt = "image-attachments";

  const resetFileUploadStore = () => {
    imageLoading.set(false);
    imageError.set(false);
    imageUrl.set(null);
  };

  const getImageUrl = async (file) => {
    console.log(file);
    imageLoading.set(true);
    imageError.set(false);

    try {
      const compressedFile = await new ImageResizor(file, {
        outputType: "image/jpeg",
        quality: 1,
      })
        .init()
        .then((instance) => instance.toBlob())
        .catch((e) => console.log(e));
      console.log(compressedFile);
      if (!compressedFile) throw new Error("image resizor error");
      const storageId = uuidv4() + Date.now().toString();
      const storageRef = ref(storage, `${storeAt}/${storageId}`);
      const snapshot = await uploadBytes(storageRef, compressedFile);
      if (!snapshot)
        throw new Error("something went wrong uploading the photo");
      const downloadUrl = await getDownloadURL(snapshot.ref);
      console.log(downloadUrl, "downloadUrl");
      console.log(snapshot);
      if (!downloadUrl) throw new Error("did not get the download url");
      return downloadUrl;
    } catch (err) {
      console.log(err);
      imageError.set(err.message);
    } finally {
      imageLoading.set(false);
    }
  };

  return {
    imageLoading,
    imageError,
    imageUrl,
    resetFileUploadStore,
    getImageUrl,
  };
};

export const fileUploadStore = fileUpload();
export const mailDeliveryStore = mailUpload();
